const n = { r: 'number' },
	s = { r: 'string' },
	a = { r: 'array' },
	b = { r: '' };
export const shellyKeyWords = {
	methods: ['die', 'chr', 'print'],
	Shelly: {
		methods: {
			call: '',
			addEventHandler: '',
			addStatusHandler: '',
			removeEventHandler: b,
			removeStatusHandler: b,
			emitEvent: '',
			getComponentConfig: '',
			getDeviceInfo: {
				params: {
					slot: n,
					model: s,
					gen: n,
					fw_id: s,
					ver: s,
					app: s,
					auth_en: b,
					auth_domain: s,
				},
			},
			getCurrentScriptId: n,
			getComponentStatus: '',
			getUptimeMs: n,
		},
	},
	Timer: {
		methods: {
			set: '',
			clear: '',
			getInfo: {
				interval: n,
				next: n,
			},
		},
	},
	MQTT: {
		methods: {
			isConnected: b,
			subscribe: '',
			unsubscribe: b,
			publish: b,
			setConnectHandler: '',
			setDisconnectHandler: '',
		},
	},
	'BLE.Scanner': {
		methods: {
			subscribe: '',
			Start: '',
			Stop: b,
			isRunning: b,
			GetScanOptions: '',
		},
		params: {
			SCAN_START: n,
			SCAN_STOP: n,
			SCAN_RESULT: n,
			INFINITE_SCAN: n,
		},
	},
	'BLE.GAP': {
		methods: {
			parseName: s,
			parseManufacturerData: s,
			ParseDataByEIRType: s,
			HasService: b,
			ParseServiceData: s,
		},
		params: {
			ADDRESS_TYPE_PUBLIC: n,
			ADDRESS_TYPE_RANDOM_STATIC: n,
			ADDRESS_TYPE_RANDOM_NON_RESOLVABLE: n,
			ADDRESS_TYPE_RANDOM_RESOLVABLE: n,
			EIR_FLAGS: n,
			EIR_SERVICE_16_INCOMPLETE: n,
			EIR_SERVICE_16: n,
			EIR_SERVICE_32_INCOMPLETE: n,
			EIR_SERVICE_32: n,
			EIR_SERVICE_128_INCOMPLETE: n,
			EIR_SERVICE_128: n,
			EIR_SHORT_NAME: n,
			EIR_FULL_NAME: n,
			EIR_TX_POWER_LEVEL: n,
			EIR_DEVICE_ID: n,
			EIR_SERVICE_DATA_16: n,
			EIR_SERVICE_DATA_32: n,
			EIR_SERVICE_DATA_128: n,
			EIR_URL: n,
			EIR_MANUFACTURER_SPECIFIC_DATA: n,
		},
	},
	HTTPServer: {
		methods: {
			registerEndpoint: s,
		},
	},
	'Script.id': n,
	'Script.storage': {
		methods: {
			key: n,
			getItem: s,
			setItem: '',
			removeItem: '',
			clear: '',
		},
		params: {
			length: n,
		},
	},
	Virtual: {
		methods: {
			getHandle: {
				methods: {
					setValue: '',
					getValue: '',
					getStatus: '',
					getConfig: '',
					setConfig: '',
					on: '',
				},
			},
		},
	},
};
export const jsKeyWords = {
	params: [
		'let',
		'var',
		'this',
		'typeof',
		'in',
		'null',
		'return',
		'continue',
		'break',
		'try',
		'catch',
		'delete',
		'true',
		'false',
		'const',
		'undefined',
	],
	methods: ['do', 'for', 'bind', 'while', 'switch', 'btoa', 'atob', 'btoh', 'case'],
	JSON: {
		methods: {
			parse: '',
			stringify: s,
		},
	},
	Object: {
		methods: {
			keys: a,
			create: '',
		},
	},
	console: {
		methods: {
			log: '',
		},
	},
	arguments: {
		params: {
			length: n,
		},
	},
	Number: {
		params: {
			MAX_VALUE: n,
			MIN_VALUE: n,
			NaN: '',
			NEGATIVE_INFINITY: n,
			POSITIVE_INFINITY: n,
		},
	},
	'new Number': {
		methods: {
			toFixed: s,
		},
	},
	Math: {
		methods: {
			abs: n,
			acos: n,
			asin: n,
			atan: n,
			atan2: n,
			ceil: n,
			cos: n,
			exp: n,
			floor: n,
			log: n,
			max: n,
			min: n,
			pow: n,
			random: n,
			round: n,
			sign: n,
			sin: n,
			sqrt: n,
			tan: n,
			wrap: n,
		},
		params: {
			E: n,
			LN10: n,
			LN2: n,
			LOG10E: n,
			LOG2E: n,
			PI: n,
			SQRT1_2: n,
			SQRT2: n,
		},
	},
	Function: {
		methods: {
			replaceWith: '',
		},
	},
	'new String': {
		params: {
			length: n,
		},
		methods: {
			charAt: s,
			charCodeAt: s,
			concat: '',
			endsWith: s,
			fromCharCode: s,
			includes: '',
			indexOf: n,
			lastIndexOf: n,
			localeCompare: n,
			match: a,
			padEnd: s,
			padStart: s,
			repeat: s,
			replace: s,
			slice: s,
			split: s,
			startsWith: '',
			substr: s,
			toLowerCase: s,
			toUpperCase: s,
			trim: s,
			at: s,
		},
	},
	Array: {
		methods: {
			isArray: '',
		},
	},
	'new Array': {
		params: {
			length: n,
		},
		methods: {
			concat: a,
			every: '',
			fill: a,
			filter: a,
			find: a,
			findIndex: n,
			forEach: n,
			includes: '',
			indexOf: n,
			join: s,
			map: a,
			pop: '',
			push: n,
			reduce: '',
			reverse: a,
			shift: '',
			slice: a,
			some: '',
			sort: a,
			splice: a,
			toString: s,
			unshift: '',
		},
	},
	Date: {
		methods: {
			now: n,
			parse: n,
		},
	},
	'new Date': {
		methods: {
			getDate: n,
			getDay: n,
			getFullYear: n,
			getHours: n,
			getIsDST: '',
			getMilliseconds: n,
			getMinutes: n,
			getMonth: n,
			getSeconds: n,
			getTime: n,
			getTimezoneOffset: n,
			setDate: n,
			setFullYear: n,
			setHours: n,
			setMilliseconds: n,
			setMinutes: n,
			setMonth: n,
			setSeconds: n,
			setTime: n,
			toISOString: s,
			toJSON: s,
			toLocalISOString: s,
			toString: s,
			toUTCString: s,
			valueOf: n,
		},
	},
};
